import { render, staticRenderFns } from "./TrendChart.vue?vue&type=template&id=21e22fdc&scoped=true&lang=html"
import script from "./TrendChart.vue?vue&type=script&lang=js"
export * from "./TrendChart.vue?vue&type=script&lang=js"
import style0 from "./TrendChart.vue?vue&type=style&index=0&id=21e22fdc&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "21e22fdc",
  null
  
)

export default component.exports